"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _auth = require("../store/auth.selectors");

var HasAbilities = function HasAbilities(_ref) {
  var children = _ref.children,
      abilities = _ref.abilities,
      fallbackUrl = _ref.fallbackUrl;
  var userAbilities = (0, _reactRedux.useSelector)(_auth.getAuthAbilities);
  var hasSomeOfAbility = userAbilities.some(function (userAbility) {
    return abilities.includes(userAbility);
  });
  return hasSomeOfAbility ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: fallbackUrl
  });
};

HasAbilities.defaultProps = {
  fallbackUrl: '/access-denied'
};
HasAbilities.propTypes = {
  fallbackUrl: _propTypes.default.string,
  abilities: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = HasAbilities;
exports.default = _default;